import refactorFoods from "./refactorFoods"

const getComboItemFoodDetail = (
  comboItem,
  comboSetId,
  comboBranchId
) => {
  const [food] =
    refactorFoods([comboItem.foodId], comboBranchId)

  const option =
    food.options.find(o => o._id === comboItem.optionId)

  return {
    comboSetId,
    comboSetItemId: comboItem._id,
    foodId: food._id,
    foodImageCover: food.imageCover,
    foodName: food.name,
    foodCode: food.code,
    addAmount: comboItem.addAmount,
    optionId: option._id,
    optionName: option.name,
    salePrice: option.salePrice,
    quantity: comboItem.quantity,
    taxItems: food.taxItemIds,
    isSimple: food.isSimple,
    unit: food.unit,
    outOfStock: option.outOfStock,
    taxInclusive: food.taxInclusive,
    isAvailable: option.isAvailable,
    stockManagement: option.stockManagement,
    availableQuantity: option.availableQuantity,
  }
}

export default getComboItemFoodDetail